export default __webpack_public_path__ + "static/media/portharcout-1.be16cd1f.webp";